<template>
    <v-row no-gutters>
    <v-col v-if="showAvatar && getenableADA" class="d-flex my-3" align="center" justify="center" cols="12">
            <!-- <v-icon size="80" class="ml-10" @click="$router.push('/'); backHome()" color="primary">
                mdi-arrow-left-circle
            </v-icon> -->

            <v-btn color="primary" class="ml-10" height="50" @click="
        $router.push('/');
      backHome();
      ">
        <v-icon size="45" class="mr-2">
          mdi-arrow-left
        </v-icon>
        Back
      </v-btn>
            
            <v-spacer></v-spacer>
            <span class="text-h3 ml-n10 font-weight-bold my-auto ada-ignore-text-size">
                {{ pageHeader }}
            </span>
            <v-spacer></v-spacer>
        </v-col>

        <v-col class="mr-5" v-if="showAvatar" cols="1">
            <avatar :initialWidth="190"></avatar>
        </v-col>
        <v-col>
            <v-card class="bubbleBorder px-5" height="180" color="rgba(30, 101, 39, 0.88)">
                <v-row no-gutters class="fill-height ma-0 pa-0">
                    <v-col class="px-5" align="center" align-self="center" cols="11">
                        <span :class="{ 'text-h4': getTextBubbleText.length >= 200 }"
                            class="white--text text-h3 font-weight-medium pl-5 ada-ignore-text-size">
                            {{ getTextBubbleText }}
                        </span>
                    </v-col>
                    <v-col cols="1" align="center" align-self="center" v-if="!getIsThinking">
                        <v-img class="talk-button" @click="actionOnTap()" contain width="140px"
                            :src="require('../assets/' + talkButtonSrc)">
                        </v-img>
                        <span class="white--text">
                            {{ speakingStatus }}
                        </span>
                    </v-col>
                    <v-col v-else cols="1" align="center" align-self="center">
                        <v-img contain width="140px" :src="require('../assets/' + talkButtonSrc)">
                        </v-img>
                        <span class="white--text">
                            {{ speakingStatus }}
                        </span>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
        <v-col v-if="showAvatar && !getenableADA" class="d-flex my-3" align="center" justify="center" cols="12">
            <!-- <v-icon size="80" class="ml-10" @click="$router.push('/'); backHome()" color="primary">
                mdi-arrow-left-circle
            </v-icon> -->

            <v-btn color="primary" class="ml-10" height="50" @click="
        $router.push('/');
      backHome();
      ">
        <v-icon size="45" class="mr-2">
          mdi-arrow-left
        </v-icon>
        Back
      </v-btn>

      


            <v-spacer></v-spacer>
            <span class="text-h3 ml-n10 font-weight-bold my-auto ada-ignore-text-size">
                {{ pageHeader }}
            </span>
            <v-spacer></v-spacer>
        </v-col>
    </v-row>
</template>

<script>
import avatar from '@/components/avatar';
import { mapGetters } from 'vuex';

export default {
    name: 'appHeader',
    components: {
        avatar
    },
    data() {
        return {
            showAvatar: false,
            pageHeader: '',
            changeFont: false,
            speakingStatus: 'Tap To Talk',
            talkButtonSrc: 'talkButton.png',
        }
    },
    computed: {
        ...mapGetters(['getTextBubbleText', 'getPageHeader', 'getIsSpeaking', 'speechRecognitionStatus', 'getQnaStatus', 'getTouchCount', 'isUserLooking', 'getCurrentLanguage', 'getIsThinking','getenableADA'])
    },
    watch: {
        $route(to, from) {
            if (to.path !== '/') {
                this.showAvatar = true
            }
            else {
                this.showAvatar = false
            }
        },
        getPageHeader(newVal) {
            this.pageHeader = newVal
        },
        getIsSpeaking(newVal) {
            if (newVal) {
                this.talkButtonSrc = "stopTalking.png";
                this.speakingStatus = this.$i18n.t("isSpeaking");
                this.$store.commit("setSpeechRecognitionHandler", false);
            }
            else if (!newVal && !this.speechRecognitionStatus) {
                this.talkButtonSrc = "talkButton.png";
                this.speakingStatus = this.$i18n.t("notSpeaking");
            }
        },
        speechRecognitionStatus(newVal) {
            if (newVal) {
                this.speakingStatus = this.$i18n.t("isListening");
                this.talkButtonSrc = "talkButtonActive.webp";
            } else {
                if (!this.getIsSpeaking) {
                    this.talkButtonSrc = "talkButton.png";
                    this.speakingStatus = this.$i18n.t("notSpeaking");
                }
            }

        },
        getQnaStatus(newVal) {
            if (newVal) {
                this.speakingStatus = this.$i18n.t("isThinking");
                this.talkButtonSrc = 'talkButton.png'
            } else {
                this.talkButtonSrc = 'talkButton.png'
                this.speakingStatus = this.$i18n.t("notSpeaking")
            }
        },
        getCurrentLanguage(newVal) {
            this.speakingStatus = this.$i18n.t("notSpeaking");
        }

    },
    methods: {
        actionOnTap() {
            console.log('Speaking Status: ', this.speakingStatus)
            if (this.getIsSpeaking) {
                window.stopSpeech();
                this.$store.commit('setTextBubbleText', this.$i18n.t('bubbletextafteraction'));
                this.$store.commit("setTouchRequest", {
                    module: "Default",
                    action: "Touch Detected",
                    response: "Stop Speech Initiated",
                    timeStamp: new Date(),
                    requestType: "Touch",
                });
            } else if (this.speechRecognitionStatus) {
                console.log('Do nothing')
            }
            else {
                if (this.$i18n.locale === "en") {
                    this.$store.commit("setSpeechRecognitionHandler", true);

                    // To start session using touch - when no face detected
                    if (!this.isUserLooking) {
                        console.log("User Session started");
                        this.$store.commit("setTouchCount", this.getTouchCount + 1);
                        if (this.getTouchCount === 1) {
                            // start time
                            this.$store.commit("setStartUserSession", new Date());
                            this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
                            //session start object
                            this.$store.commit("setTouchRequest", {
                                module: "Default",
                                action: "Touch Detected",
                                response: "User Session Started - Touch Detected",
                                timeStamp: new Date(),
                                requestType: "Session",
                            });
                        }
                    }
                } else {
                    if (!this.getIsSpeaking) {
                        this.$store.dispatch("avatarSpeak", "Sé hablar en español, pero todavía estoy aprendiendo a escuchar en español.");
                    } else {
                        window.stopSpeech();
                    }
                }
            }

        },
        backHome() {
            window.stopSpeech();
            // Touch Usage
            this.$store.commit('setRequestQna', false)
            this.$store.commit("setIsThinking", false)
            this.$store.commit("setSpeechRecognitionHandler", false);
            this.$store.commit('setTextBubbleText', this.$i18n.t('bubbletextafteraction'));
            this.$store.commit('setTouchRequest', {
                module: 'App Header',
                action: 'navigate',
                response: 'Home Page',
                timeStamp: new Date(),
                requestType: 'Touch'
            })
        }
    }


}
</script>

<style scoped>
.bubbleBorder {
    border-radius: 0 0 30px 30px !important;
}

.talk-button {
    filter: sepia(19%) saturate(697%) hue-rotate(294deg) brightness(95%) contrast(350%);
}
</style>
<i18n>
{
  "en": {
      "bubbletextafteraction": "Tap the microphone button, to ask me a question.",
      "isSpeaking": "Speaking",
      "notSpeaking": "Tap To Talk",
      "isListening": "Listening",
      "isThinking": "Thinking"
    },
  "es":{
      "bubbletextafteraction": "El reconocimiento de voz está desactivado para el idioma español.",
      "isSpeaking": "Hablando",
      "notSpeaking": "Toque para hablar",
      "isListening": "Escuchando",
      "isThinking": "Pensando"
    }
}
</i18n>